import * as React from 'react';
import { translate } from 'components/translate-hoc';
import GameInstaller from 'modules/game-installer';
// utils
import { isCSSVariableSet, getModeClass } from 'utils/css';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

// types
import { ISuccessPageProps } from './success-page.types';

// constants
import {
    GAME_PACKSHOT_CSS_VARIABLE,
    TEXT_KEYS,
    SUCCESS_FLOW_STEP,
    SUCCESS_FLOW_ACTIONS
} from './success-page.constants';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import './success-page.styles.less';

export class SuccessPage extends React.Component<ISuccessPageProps, {}> {
    public componentDidMount() {
        AnalyticsService.sendFlowEvent({
            ...SUCCESS_FLOW_STEP,
            action: SUCCESS_FLOW_ACTIONS.DISPLAY,
            category: CATEGORY.DISPLAY
        });
    }

    public render(): JSX.Element {
        const {
            gameId,
            brandedInstallerUrl,
            hasBrandedInstaller,
            dangerouslyTranslateWithHTML: translateKey,
            shouldInheritStyles
        } = this.props;

        const messageText = translateKey(TEXT_KEYS.MESSAGE);
        const congratsMessage = translateKey(TEXT_KEYS.CONGRAT_MESSAGE);
        const basePageStyleClass = getModeClass('sitegen-success-page', shouldInheritStyles);
        const gamePackshotImage: JSX.Element | null = isCSSVariableSet(GAME_PACKSHOT_CSS_VARIABLE)
            ? <div className={`${basePageStyleClass}__image`}/>
            : null;

        return (
            <div className={basePageStyleClass}>
                <div className={`${basePageStyleClass}__content`}>
                    <h2 className={`${basePageStyleClass}__congrats-message`}>
                        {congratsMessage}
                    </h2>
                    <div className={`${basePageStyleClass}__fw-game-asset`}>
                        {gamePackshotImage}

                        <div className={`${basePageStyleClass}__info-block`}>
                            <div className={`${basePageStyleClass}__message`}>
                                <p>{messageText}</p>
                            </div>

                            <GameInstaller
                                gameId={gameId}
                                brandedInstallerUrl={brandedInstallerUrl}
                                hasBrandedInstaller={hasBrandedInstaller}
                                shouldInheritStyles={shouldInheritStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate()(SuccessPage);
